/** Selo de sincronização (19.2 item 5): "Tudo salvo" ou "N pendentes". */
import { useRuntime, useSyncStatus } from '@lindeza/core/hooks';
import { useEffect, useState } from 'react';
import { IconCloud, IconCloudOff, IconRefresh } from './Icons';

export function SyncBadge() {
  const rt = useRuntime();
  const status = useSyncStatus();
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  const offline = !online || status.state === 'offline';
  let label: string;
  let cls = 'sync';
  let icon = <IconCloud />;
  if (status.state === 'syncing') {
    label = 'Sincronizando…';
    icon = <IconRefresh />;
  } else if (offline) {
    label = status.pending > 0 ? `Sem internet · ${status.pending} ${status.pending === 1 ? 'pendente' : 'pendentes'}` : 'Sem internet';
    cls += ' sync--pending';
    icon = <IconCloudOff />;
  } else if (status.pending > 0) {
    label = `${status.pending} ${status.pending === 1 ? 'pendente' : 'pendentes'}`;
    cls += ' sync--pending';
  } else if (status.state === 'error') {
    label = 'Erro ao sincronizar';
    cls += ' sync--pending';
  } else {
    label = 'Tudo salvo';
    cls += ' sync--ok';
  }
  return (
    <button className={cls} onClick={() => void rt.sync.sync()} aria-label={`${label}. Toque para sincronizar agora.`} data-testid="sync-badge">
      {icon}
      {label}
    </button>
  );
}
